import { Link } from "react-router-dom";
import { API } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { useCart } from "@/context/CartContext";
import { FileText, Check, Plus, GraduationCap } from "lucide-react";

const gradients = [
  "from-blue-500 to-indigo-600",
  "from-sky-500 to-blue-700",
  "from-cyan-500 to-blue-600",
  "from-indigo-500 to-blue-700",
];

export const NoteCard = ({ note, index = 0 }) => {
  const { addItem, inCart } = useCart();
  const g = gradients[index % gradients.length];
  const owned = note.owned;

  return (
    <div
      className="group bg-white border border-border rounded-xl overflow-hidden shadow-sm hover:-translate-y-1 hover:shadow-md transition-transform transition-shadow duration-200 flex flex-col"
      data-testid={`note-card-${note.id}`}
    >
      <Link to={`/note/${note.id}`} className="block">
        <div className="relative aspect-[4/3] overflow-hidden">
          {note.has_cover ? (
            <img
              src={`${API}/notes/${note.id}/cover`}
              alt={note.title}
              className="h-full w-full object-cover"
            />
          ) : (
            <div className={`h-full w-full bg-gradient-to-br ${g} flex items-center justify-center`}>
              <FileText className="h-12 w-12 text-white/80" />
            </div>
          )}
          <span className="absolute top-3 left-3 text-[10px] font-semibold uppercase tracking-overline bg-white/90 text-slate-700 px-2.5 py-1 rounded-full">
            {note.subject}
          </span>
        </div>
      </Link>

      <div className="p-4 flex flex-col gap-2 flex-1">
        <Link to={`/note/${note.id}`}>
          <h3 className="font-heading font-semibold text-slate-900 leading-tight line-clamp-2 group-hover:text-primary transition-colors">
            {note.title}
          </h3>
        </Link>
        <p className="text-xs text-muted-foreground">by {note.seller_name}</p>
        {note.level && (
          <span className="inline-flex items-center gap-1 text-[11px] font-medium text-primary" data-testid={`note-level-${note.id}`}>
            <GraduationCap className="h-3.5 w-3.5" /> {note.level}
          </span>
        )}
        <div className="mt-auto flex items-center justify-between pt-2">
          <span className="font-heading font-bold text-lg text-slate-900" data-testid={`note-price-${note.id}`}>
            ₹{note.price}
          </span>
          {owned ? (
            <span className="text-xs font-medium text-emerald-600 flex items-center gap-1">
              <Check className="h-4 w-4" /> Owned
            </span>
          ) : (
            <Button
              size="sm"
              variant={inCart(note.id) ? "secondary" : "default"}
              className="rounded-full"
              onClick={() => addItem(note)}
              disabled={inCart(note.id)}
              data-testid={`add-cart-${note.id}`}
            >
              {inCart(note.id) ? (
                <>
                  <Check className="h-4 w-4 mr-1" /> Added
                </>
              ) : (
                <>
                  <Plus className="h-4 w-4 mr-1" /> Add
                </>
              )}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
